<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware/>
    <div class="container-terms">
      <div style="margin-left: 20%;margin-bottom:10%">
        <h1>YourSynchronicity Terms of Service</h1>
      </div>
      <p>
        Please read these “Terms of Service” carefully before using the YourSynchronicity.com
        services
        and/or YourSynchronicity.com website operated by YourSynchronicity ("us", "we", or "our").
        <br><br>
        Your access to and use of the Service is conditioned on your acceptance of and compliance
        with these Terms. These Terms apply to all visitors, users and others who access or use the
        Service.
        <br><br>
        By accessing or using the Service you agree to be bound by these Terms. If you disagree with
        any part of the terms then you may not access the Service.
      </p>
      <h2>Subscriptions</h2>
      <p>
        All services are billed on a subscription basis ("Subscription(s)") except the free trial
        period. You will be billed in advance on a recurring and periodic basis ("Billing Cycle").
        Billing cycles are set on a monthly basis.
        <br><br>
        At the end of each Billing Cycle, your Subscription will automatically renew under the exact
        same conditions unless you cancel it or YourSynchronicity cancels it. You may cancel your
        Subscription at anytime from your account settings page on YourSynchronicity.
        <br><br>
        A valid payment method is required to process the payment for your Subscription. You shall
        provide accurate and complete billing information and valid payment method information. By
        submitting such payment information, you automatically authorize YourSynchronicity to charge
        all
        Subscription fees incurred through your account to any such payment instruments.
      </p>
      <h2>Fee Changes</h2>
      <p>
        YourSynchronicity, in its sole discretion and at any time, may modify the Subscription fees
        for the
        Subscriptions. Any Subscription fee change will become effective at the end of the
        then-current Billing Cycle. YourSynchronicity will provide you with a reasonable prior
        notice of
        any change in Subscription fees to give you an opportunity to terminate your Subscription
        before such change becomes effective.
        <br><br>
        Your continued use of the Service after the Subscription fee change comes into effect
        constitutes your agreement to pay the modified Subscription fee amount.
      </p>
      <h2>Refunds</h2>
      <p>
        Except when required by law, paid Subscription fees are non-refundable.
      </p>
      <h2>Accounts</h2>
      <p>
        When you create an account with us, you must provide us information that is accurate,
        complete, and current at all times. Failure to do so constitutes a breach of the Terms,
        which may result in immediate termination of your account on our Service.
        <br><br>
        You are responsible for safeguarding the password that you use to access the Service and for
        any activities or actions under your password, whether your password is with our Service or
        a third-party service.
        <br><br>
        You agree not to disclose your password to any third party. You must notify us immediately
        upon becoming aware of any breach of security or unauthorized use of your account.
        <br><br>
        You may not use as a username the name of another person or entity or that is not lawfully
        available for use, a name or trademark that is subject to any rights of another person or
        entity other than you without appropriate authorization, or a name that is otherwise
        offensive, vulgar or obscene. You expressly agree that we cannot be held liable for any loss
        or damage arising out of any misrepresentations you make in this regard.
        <br><br>
        You agree not to attempt to hack, reverse engineer or damage YourSynchronicity or any of the
        services YourSynchronicity offers in any way.
      </p>
      <h2>Intellectual Property</h2>
      <p>
        The Service and its original content, features and functionality are and will remain the
        exclusive property of YourSynchronicity and its licensors.
      </p>
      <h2>Connecting to Linkedin</h2>
      <p>Our Service connects to LinkedIn services that are not owned or controlled by
        YourSynchronicity.
        <br><br>
        YourSynchronicity has no control over, and assumes no responsibility for, the content,
        privacy
        policies, terms of use, or practices of LinkedIn. You further acknowledge and agree that
        YourSynchronicity shall not be responsible or liable, directly or indirectly, for any damage
        or
        loss caused or alleged to be caused by or in connection with use of or reliance on any such
        content, goods or services available on or through “YourSynchronicity”s website and it
        services.
        <br><br>
        We strongly advise you to read the terms and conditions and privacy policies of any
        third-party websites or services that you visit.</p>
      <h2>Termination</h2>
      <p>We may terminate or suspend your account immediately, without prior notice or liability,
        for any reason whatsoever, including without limitation if you breach the Terms.
        <br><br>
        Upon termination, your right to use the Service will immediately cease. If you wish to
        terminate your account, you may simply discontinue using the Service.
        <br><br>
        All provisions of the Terms which by their nature should survive termination shall survive
        termination, including, without limitation, ownership provisions, warranty disclaimers,
        indemnity and limitations of liability.</p>
      <h2>Indemnification</h2>
      <p>You agree to defend, indemnify and hold harmless YourSynchronicity and its licensee and
        licensors,
        and their employees, contractors, agents, officers and directors, from and against any and
        all claims, damages, obligations, losses, liabilities, costs or debt, and expenses
        (including but not limited to attorney's fees), resulting from or arising out of a) your use
        and access of the Service, by you or any person using your account and password, or b) a
        breach of these Terms.</p>
      <h2>Limitation Of Liability</h2>
      <p>In no event shall YourSynchronicity, nor its principals, directors, employees, partners,
        agents,
        suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or
        punitive damages, including without limitation, loss of profits, data, use, goodwill, or
        other intangible losses, resulting from (i) your access to or use of or inability to access
        or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any
        content obtained from the Service; and (iv) unauthorized access, use or alteration of your
        transmissions or content, whether based on warranty, contract, tort (including negligence)
        or any other legal theory, whether or not we have been informed of the possibility of such
        damage, and even if a remedy set forth herein is found to have failed of its essential
        purpose.
        <br><br>
        YourSynchronicity is in no way affiliated or connected with LinkedIn. By using
        www.YourSynchronicity.com,
        you agree that YourSynchronicity holds no responsibility for any losses or liabilities
        incurred,
        including the imposition of restrictions, penalties and bans by LinkedIn.</p>
      <h2>Disclaimer</h2>
      <p>
        Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS
        AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or
        implied, including, but not limited to, implied warranties of merchantability, fitness for a
        particular purpose, non-infringement or course of performance.
        <br><br>
        YourSynchronicity its principals, subsidiaries, affiliates, and its licensors do not warrant
        that
        a) the Service will function uninterrupted, secure or available at any particular time or
        location; b) any errors or defects will be corrected; c) the Service is free of viruses or
        other harmful components; or d) the results of using the Service will meet your
        requirements.
      </p>
      <h2>Governing Law</h2>
      <p>
        You are responsible for making sure you and your use of YourSynchronicity are in compliance
        with
        any local laws and the laws of the country you are accessing and/or using the services in
        and/or from. The use of YourSynchronicity is not intended for engaging in spam or harassing
        behavior. You agree not to use YourSynchronicity to engage in a spamming behavior. Do not
        use this
        service for any illegal activities or for offering or facilitating any illegal activities.
        <br><br>
        Our failure to enforce any right or provision of these Terms will not be considered a waiver
        of those rights. If any provision of these Terms is held to be invalid or unenforceable by a
        court, the remaining provisions of these Terms will remain in effect. These Terms constitute
        the entire agreement between us regarding our Service, and supersede and replace any prior
        agreements we might have between us regarding the Service.
      </p>
      <h2>Changes</h2>
      <p>
        YourSynchronicity reserves the right, at our sole discretion, to modify or replace these
        Terms at
        any time. If a revision is material we will try to provide at least 15 days notice prior to
        any new terms taking effect. What constitutes a material change will be determined at our
        sole discretion.
        <br><br>
        By continuing to access or use our Service after those revisions become effective, you agree
        to be bound by the revised terms. If you do not agree to the new terms, you must stop using
        the service.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at
        support@yoursynchronicity.com
      </p>
    </div>
    <FooterMain/>

  </div>
</template>

<script>

    import ThreeStepProcessWrap from "../../components/AeroLandingPage/ThreeStepProcessWrap";
    import HeaderSoftware from "../../components/AeroLandingPage/HeaderSoftware";
    import HeroSoftware from "../../components/AeroLandingPage/HeroSoftware";
    import BrandLogoCarousel from "../../components/AeroLandingPage/BrandLogoCarousel";
    import FeatureList from "../../components/AeroLandingPage/FeatureList";
    import TabTwo from "../../components/AeroLandingPage/TabTwo";
    import ProgressBar from "../../components/AeroLandingPage/ProgressBar";
    import PricingOne from "../../components/AeroLandingPage/PricingOne";
    import CurveShape from "../../components/AeroLandingPage/CurveShape";
    import CtaThree from "../../components/AeroLandingPage/CtaThree";
    import FunFactOne from "../../components/AeroLandingPage/FunFactOne";
    import Accordion from "../../components/AeroLandingPage/Accordion";
    import Newsletter from "../../components/AeroLandingPage/Newsletter";
    import FooterMain from "../../components/AeroLandingPage/FooterMain";
    import OffcanvasSearchBox from "../../components/AeroLandingPage/OffcanvasSearchBox";
    import SassFeature from "../../components/AeroLandingPage/SassFeature";

    // localStorage.clear();
    export default {
        name: "terms",
        components: {
            HeaderSoftware,
            HeroSoftware,
            BrandLogoCarousel,
            SassFeature,
            FeatureList,
            TabTwo,
            ProgressBar,
            PricingOne,
            CurveShape,
            CtaThree,
            FunFactOne,
            Accordion,
            Newsletter,
            FooterMain,
            OffcanvasSearchBox,
            ThreeStepProcessWrap,
        },
        created() {
        }

    };
</script>
<style scoped>
  .container-terms {
    margin-top: 20%;
    margin-left: 25%;
    max-width: 50%;
  }
</style>
